import { Plugins } from '@leverege/plugin';
import FontSize from "./FontSize.js";
import WidgetNode from "./WidgetNode.js";
import ValueRenderers from "./valueRenderers/PluginSetup.js";
import Color from "./Color.js";
import LevTextNode from "./LevTextNode.js";
import LevTextMark from "./LevTextMark.js";
export default {
  install: (opts = Plugins) => {
    opts.addPlugin('TiptapExtension', FontSize);
    opts.addPlugin('TiptapExtension', WidgetNode);
    // opts.addPlugin( 'TiptapExtension', LevTextNode )
    opts.addPlugin('TiptapExtension', LevTextMark);
    opts.addPlugin('TiptapExtension', Color);
    ValueRenderers.install(opts);
  }
};